import { graphql } from 'src/gql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQL } from 'src/hooks/useGraphQL'

const document = graphql(/* graphql */`
  query eeocDocById($id: MongoID!) {
    cat {
      eeoc {
        byId(_id: $id) {
          _id
          envelope
          documents
          _candidate {
            lastFirstName 
          }
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type EeocDocById = NonNullable<NonNullable<NonNullable<NonNullable<TData>['cat']>['eeoc']>['byId']>

const useEeocDocById = (id: string): EeocDocById | null | undefined => {
  const { data } = useGraphQL(document, { id }, {
    enabled: typeof id === 'string'
  })
  return data?.cat?.eeoc?.byId
}

export { useEeocDocById, document as eeocDocByIdDocument }
